import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import SocialIcons from '../components/SocialIcons';
import aboutContent from '../data/aboutContent';
import { LandingVariant } from '../utils/landingVariant';
import '../styles/index.css';

interface HomeArtProps {
  variant?: LandingVariant;
}

const HomeArt: React.FC<HomeArtProps> = ({ variant }) => {
  return (
    <div className='App'>
      <h1 className='title'>B R I N A R Y</h1>
      <Header />
      <SocialIcons variant={variant} />
      <p>{aboutContent}</p>
      <Footer />
    </div>
  );
};

export default HomeArt;
